/*@flow*/
const dot = (color: string = '#0FEAA6', content: string = '"\f111"'): string => `
  &:after {
    border-radius: 10px;
    margin: 0;
    height: 10px;
    width: 10px;
    color: ${color};
    content: ${content};
    font-family: "Font Awesome 5 Pro";
    font-weight: 900;
    display: inline-block;
    font-style: normal;
    font-variant: normal;
    text-rendering: auto;
    line-height: 1;
    font-size: 0.5rem;
    position: absolute;
    top: 0px;
    right: -5px;
  },
`;

export default dot;
